import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/clients')({
  staticData: { breadcrumb: 'Clients', breadcrumbKey: 'K_BREADCRUMB_TENANTS' },
});
